import Axios from 'axios';
import { responseHandler, errorHandler } from 'common/service/utils/fosHandler';

export const FosAxiosInstance = Axios.create({
  baseURL: '',
  timeout: 9.9 * 60 * 1000, // 9.9 min, 要比丹炉超时时间短一些
});

FosAxiosInstance.interceptors.response.use(responseHandler, errorHandler);
